import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/analize/TestsBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/analize/TestsNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/analize/TestsPanels.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
